import moment, { Moment } from "moment";

export type RdoDataModo = "geral" | "semana" | "mes" | "personalizado";

export function formatRdoDate(value: Moment | Date | string): string {
  return moment(value).format("YYYY-MM-DD");
}

/** Intervalo (Moment) conforme o modo — usado no filtro e no envio à API. */
export function getRdoDateMoments(modo: RdoDataModo): {
  inicio: Moment | null;
  fim: Moment | null;
} {
  if (modo === "semana") {
    return {
      inicio: moment().startOf("week"),
      fim: moment().endOf("week"),
    };
  }

  if (modo === "mes") {
    return {
      inicio: moment().startOf("month"),
      fim: moment().endOf("month"),
    };
  }

  return { inicio: null, fim: null };
}

export function resolveRdoDataRange(
  modo: RdoDataModo,
  dataInicio: string | null | undefined,
  dataFim: string | null | undefined
): { DataInicio?: string; DataFim?: string } {
  if (modo === "geral") {
    return {};
  }

  if (modo === "personalizado") {
    return {
      ...(dataInicio ? { DataInicio: formatRdoDate(dataInicio) } : {}),
      ...(dataFim ? { DataFim: formatRdoDate(dataFim) } : {}),
    };
  }

  const { inicio, fim } = getRdoDateMoments(modo);
  if (!inicio || !fim) {
    return {};
  }

  return {
    DataInicio: formatRdoDate(inicio),
    DataFim: formatRdoDate(fim),
  };
}
